import { useRef, useEffect, DependencyList } from 'react';

function useDebounceEffect(effect: () => void, delay: number, deps: DependencyList) {
  const firstRender = useRef(true);
  const lastExecution = useRef(Date.now());
  const timeoutRef = useRef<NodeJS.Timeout | undefined>();

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    const now = Date.now();
    if (now - lastExecution.current < delay) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        lastExecution.current = now;
        effect();
      }, delay);
      return;
    }

    lastExecution.current = now;
    effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [effect, delay, ...deps]);
}

export default useDebounceEffect